import { useTranslation } from 'react-i18next'
import { OpspbSubmitAuthorizationRequest } from '@itsrever/rever-api'
import { submitAuthorization } from '@/api/ops-api'
import { useProcessAction } from './use-process-action'

export function useSubmitAuthorization() {
  const { t } = useTranslation()
  return useProcessAction({
    action: (request: OpspbSubmitAuthorizationRequest) =>
      submitAuthorization({ opspbSubmitAuthorizationRequest: request }),
    errorText: t('review_toast.error'),
    reloadAfterMs: 200
  })
}
